import React from "react";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";

interface OptionalFieldsModalProps {
  open: boolean;
  onClose: () => void;
  description: string;
  onDescriptionChange: (description: string) => void;
}

const OptionalFieldsModal: React.FC<OptionalFieldsModalProps> = ({
  open,
  onClose,
  description,
  onDescriptionChange,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Optional Fields
        </Typography>
        <TextField
          fullWidth
          label="Event Description"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          margin="normal"
          multiline
        />
        <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>Close</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default OptionalFieldsModal;
